import React from "react";
import styles from "./ReceiptInfoPanel.module.css";
import {
  FiMapPin,
  FiClock,
  FiFileText,
  FiAlertTriangle,
} from "react-icons/fi";
import { BsCheckCircleFill, BsExclamationCircleFill } from "react-icons/bs";

export default function ReceiptInfoPanel({ receipt, getStatusColor }) {
  if (!receipt) return null;

  const products = Array.isArray(receipt.products) ? receipt.products : [];
  const total = products.reduce((s, p) => s + (p.actual_quantity || 0), 0);
  const scanned = products.reduce((s, p) => s + (p.marks?.length || 0), 0);
  const completion = total ? Math.min(scanned / total, 1) : 0;

  const changedAt = receipt.status_changed_at
    ? new Date(receipt.status_changed_at).toLocaleTimeString("ru-RU", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
    : "—";

  return (
    <div className={styles.panel}>
      {/* === Верхняя секция === */}
      <div className={styles.header}>
        <div className={styles.left}>
          <FiFileText className={styles.icon} />
          <span className={styles.num}>#{receipt.receipt_number}</span>
          {receipt.contract_number && (
            <span className={styles.contract}>({receipt.contract_number})</span>
          )}
          <span className={styles.client}>
            {receipt.client_name || "Без клиента"}
          </span>
        </div>

        <div className={styles.right}>
          <span
            className={styles.status}
            style={{ color: getStatusColor(receipt.status) }}
          >
            {receipt.status}
          </span>
          <FiClock className={styles.iconSmall} />
          <span className={styles.time}>{changedAt}</span>
        </div>
      </div>

      {/* === Адрес и причина === */}
      <div className={styles.middle}>
        <FiMapPin className={styles.iconSmall} />
        <span className={styles.addr}>{receipt.delivery_address || "—"}</span>
        {receipt.reason && (
          <span className={styles.reason}>
            <FiAlertTriangle className={styles.iconSmall} />
            {receipt.reason}
          </span>
        )}
      </div>

      {/* === Прогресс выполнения === */}
      <div className={styles.progressRow}>
        <div className={styles.progressBar}>
          <div
            className={styles.progressFill}
            style={{
              width: `${completion * 100}%`,
              backgroundColor:
                completion < 0.5
                  ? "#f59e0b"
                  : completion < 1
                  ? "#3b82f6"
                  : "#16a34a",
            }}
          />
        </div>
        {completion >= 1 ? (
          <span className={styles.ok}>
            <BsCheckCircleFill size={14} /> Завершено
          </span>
        ) : (
          <span className={styles.warn}>
            <BsExclamationCircleFill size={14} /> Скан {scanned}/{total}
          </span>
        )}
      </div>

      {/* === Товары === */}
      {products.length > 0 && (
        <div className={styles.products}>
          {products.map((p, i) => {
            const scannedCount = p.marks?.length || 0;
            const allScanned = scannedCount >= (p.actual_quantity || 0);
            const partial = scannedCount > 0 && !allScanned;

            return (
              <div
                key={i}
                className={`${styles.product} ${
                  allScanned
                    ? styles.prodDone
                    : partial
                    ? styles.prodPartial
                    : styles.prodNone
                }`}
              >
                <span className={styles.prodName}>{p.product_name}</span>
                {p.is_marked && (
                  <span className={styles.prodCount}>
                    {scannedCount}/{p.actual_quantity}
                  </span>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
